<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;margin-top: 1rem;" class="fontMS700 font-45 colorPrincipal">
            GRAMÁTICAS, CATECISMOS<br> Y VOCABULARIOS <br>
            <span class="fontMS300">
                EN LENGUAS ORIGINARIAS<br>
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio6/gramaticas">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio6/gramaticas">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio6/gramaticas">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img id="titleImagen2" src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img001.jpg">
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-justify font-24">
                    DURANTE EL SIGLO XVI LAS IMPRENTAS REQUERÍAN AUTORIZACIÓN PARA FUNCIONAR EN EL VIRREINATO DEL PERÚ.
                    PUESTO QUE LA EVANGELIZACIÓN ERA UNA PRIORIDAD PARA LA CORONA ESPAÑOLA, EL REY FELIPE II LE CONCEDE
                    LICENCIA REAL AL IMPRESOR ITALIANO ANTONIO RICARDO. EN 1584 SE IMPRIME <span
                        class="fontMS500Italic">DOCTRINA CHRISTIANA</span>, EL PRIMER LIBRO DE SUDAMÉRICA, EN UNA
                    EDICIÓN TRILINGÜE.
                </p>
                <p class="fontMS100 text-justify font-24">
                    <span class="fontMS100Italic">Doctrina christiana</span> es la primera de una serie de libros
                    publicados en el Perú al servicio de la evangelización. Estos vocabularios, gramáticas, catecismos y
                    sermones contienen material lingüístico de gran valor. Muchos de los traductores entendían sus obras
                    como prueba de la elocuencia y belleza de las lenguas originarias. Al mismo tiempo, sus decisiones
                    lingüísticas y estrategias expresivas subrayan los debates religiosos y tensiones interculturales de
                    ese período. A partir de la colección Paul Rivet y el Fondo Antiguo de la Biblioteca Nacional del
                    Perú, el presente recorrido presenta un panorama de textos religiosos en lenguas originarias, desde
                    el periodo virreinal hasta el nuevo auge de estudio lingüístico a comienzos del siglo XX.
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco_L">
    <div class="container">
        <div class="col-sm-12">
            <p>
                <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
            </p>
        </div>
    </div>
</div>

<div class="fondoBlanco_PR">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS300 text-center colorPrincipal font-40">
                            LA COLECCIÓN <br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS700 text-center colorPrincipal font-40">
                    PAUL RIVET
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 5%;margin-bottom: 10%;" width="100%"
                        src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada.png">
                </div>
                <div class="row mt-5 mb-5">
                    <div class="col-sm-5">
                        <p class="fontMS500 font-24 p2">
                            LA BIBLIOTECA NACIONAL ADQUIERE LA COLECCIÓN DEL RECONOCIDO ETNÓLOGO Y AMERICANISTA FRANCÉS
                            PAUL RIVET EN 1957. CONTIENE MÁS DE MIL DOCUMENTOS RELACIONADOS CON EL ESTUDIO DEL QUECHUA,
                            EL AYMARA Y LAS CULTURAS INDÍGENAS.
                        </p>
                    </div>
                    <div class="col-sm-7 bottom_cel ">
                        <p class="text-justify fontMS100 font-24 p2_1">
                            Esta amplia colección incluye gramáticas y catecismos del periodo virreinal, libros
                            bilingües y trilingües que hoy forman parte del patrimonio cultural del mundo. También hay
                            partituras, cartillas pedagógicas, poesía, obras de teatro y novelas, estudios lingüísticos,
                            históricos y arqueológicos. Estos documentos manifiestan la reivindicación de las culturas
                            indígenas desde el arte, la literatura y las ciencias sociales en el siglo XX. Nos invitan a
                            reflexionar sobre la identidad nacional. Aunque su lectura, en algunos casos, no sea fácil,
                            estos documentos resaltan desafíos y tensiones que siguen vigentes en nuestro país
                            pluricultural y plurilingüe.
                        </p>
                    </div>

                    <div class="c100">
                        <p class="text-justify fontMS100 font-24 p2_1">
                            Esta amplia colección incluye gramáticas y catecismos del periodo virreinal, libros
                            bilingües y trilingües que hoy forman parte del patrimonio cultural del mundo. También hay
                            partituras, cartillas pedagógicas, poesía, obras de teatro y novelas, estudios lingüísticos,
                            históricos y arqueológicos. Estos documentos manifiestan la reivindicación de las culturas
                            indígenas desde el arte, la literatura y las ciencias sociales en el siglo XX. Nos invitan a
                            reflexionar sobre la identidad nacional. Aunque su lectura, en algunos casos, no sea fácil,
                            estos documentos resaltan desafíos y tensiones que siguen vigentes en nuestro país
                            pluricultural y plurilingüe.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris_PR">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-5">
                <p class="imgPaulRivet text-right">
                    <img class="imgNP" width="70%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img002.jpg">
                    <br>
                    <span class="fontMS100Italic t5">Fuente: Biblioteca Nacional Digital de Chile</span>
                </p>
            </div>
            <div class="col-sm-7 bottom_cel">
                <p style="line-height: 100%;" class="fontMS300 font-24">
                    <span class="font-40 fontMS500">PAUL RIVET</span><br> (Francia, 1876-1959)
                </p>
                <p class="font-24 text-gris text-justify">
                    <br>
                    Llega a Sudamérica por primera vez en 1901 como parte de la Segunda Misión Geodésica. Durante varios
                    años documenta la historia natural de Ecuador y termina rechazando las prácticas imperantes de la
                    antropología en ese momento. En lugar de medir y clasificar a los seres humanos, Rivet promueve la
                    etnología como una manera de apreciar la igualdad de las sociedades. Dedica los últimos años de su
                    vida al estudio de la diversidad lingüística en la región andina. Antes de fallecer traslada parte
                    de su colección a la Biblioteca Nacional del Perú.
                </p>
            </div>
            <div class="c100">
                <p style="line-height: 100%;" class="fontMS300 font-24">
                    <span class="font-40 fontMS500">PAUL RIVET</span><br> (Francia, 1876-1959)
                </p>
                <p class="text-justify fontMS100 font-24 p2_1">
                    Llega a Sudamérica por primera vez en 1901 como parte de la Segunda Misión Geodésica. Durante varios
                    años documenta la historia natural de Ecuador y termina rechazando las prácticas imperantes de la
                    antropología en ese momento. En lugar de medir y clasificar a los seres humanos, Rivet promueve la
                    etnología como una manera de apreciar la igualdad de las sociedades. Dedica los últimos años de su
                    vida al estudio de la diversidad lingüística en la región andina. Antes de fallecer traslada parte
                    de su colección a la Biblioteca Nacional del Perú.
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoMarron_PP">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            EL PODER DE LA PALABRA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_LINEA1-recortada2.png">
                    </div>
                </div>
                <p class=" fontMS500 text-white text-center font-24">
                    <br><br>
                    EN EL SIGLO XVI EMPIEZAN A CIRCULAR LAS PRIMERAS TRADUCCIONES DE LOS TEXTOS SAGRADOS AL QUECHUA Y
                    AYMARA. A FALTA DE EQUIVALENCIAS EXACTAS PARA CONCEPTOS COMO PENITENCIA, ALMA O DIOS, SURGEN
                    DIVERSAS ESTRATEGIAS. ALGUNOS TRADUCTORES BUSCAN UN TÉRMINO LO MÁS PARECIDO POSIBLE. OTROS
                    INTRODUCEN PRÉSTAMOS DEL CASTELLANO O CREAN NEOLOGISMOS. PARA LAS AUTORIDADES RELIGIOSAS DE LA
                    COLONIA, ESTAS VARIACIONES ERAN PELIGROSAS PORQUE GENERABAN CONFUSIONES Y PARECÍAN SUGERIR QUE LA
                    PALABRA DIVINA,<br> Y POR EXTENSIÓN LA AUTORIDAD REAL, ES MUTABLE.
                </p>
                <p class="fontMS100 text-white text-justify font-24">
                    <br>
                    Es dentro de este contexto que el Tercer Concilio Limense se reúne entre 1582 y 1583. Entre otros
                    temas, las autoridades religiosas discuten las bases para la elaboración de materiales bilingües y
                    trilingües. Optan por el uso de préstamos del castellano para prevenir sincretismos con las
                    creencias indígenas. Los materiales aprobados por el Concilio además contienen glosarios y
                    anotaciones sobre las traducciones. Así, el Concilio busca controlar y unificar el contenido de las
                    traducciones. La llegada de la imprenta a Lima en esos mismos años facilita la reproducción y
                    difusión de estas traducciones autorizadas.
                    <br><br>
                </p>
                <div class="row pos-r">
                    <div class="col-sm-2">
                        <p><br></p>
                    </div>
                    <div class="col-sm-4">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/13066" style="color: inherit;">
                                <img width="100%" class="p-3 img-fluid imgNP_sp"
                                    src="\assets\images\micrositio\micrositio6\E03-MS08-GRAMA_img003.jpg">
                                <div class="overlay2">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Anónimo.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Doctrina christiana, y catecismo para instrvccion de los indios, y de las de
                                            mas personas, que han de ser enseñadas en nuestra sancta fé : con vn
                                            confessionario, y otras cosas necessarias.
                                            <br>
                                        </span>
                                        Antonio Ricardo, 1584.
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/34015" style="color: inherit;">
                                <img width="100%" class="p-3 img-fluid imgNP_sp"
                                    src="\assets\images\micrositio\micrositio6\E03-MS08-GRAMA_img004.jpg">
                                <div class="overlay2">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            José Toribio Medina.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            La imprenta en Lima (1584-1824), tomo I.
                                            <br>
                                        </span>
                                        Casa del autor, 1904.
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <p><br></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoMarronOscuro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-6 text-center text-white">
                <br><br><br><br><br><br>
                <img width="100%" src="\assets\images\micrositio\micrositio6\E03-MS08-GRAMA_F02.jpg">
            </div>
            <div class="col-sm-6">
                <p class="text-white fontMS500Italic font-24">
                    <br><br><br><br>
                    EL IMPRESOR ANTONIO RICARDO LLEGA A LIMA EN 1580 PERO DEBE ESPERAR TRES AÑOS HASTA RECIBIR EL
                    PERMISO NECESARIO PARA PONER EN MARCHA LA PRIMERA IMPRENTA DE SUDAMÉRICA. CURIOSAMENTE LA REAL
                    AUDIENCIA DE LIMA AUTORIZA LA IMPRESIÓN DE DOCTRINA CHRISTIANA
                    ANTES DE RECIBIR LA RESPUESTA DEL REY FELIPE II.
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-38">
                            DE LA MEMORIZACIÓN A LA PRÉDICA
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_LINEA1-recortada2.png">
                    </div>
                </div>
                <p class="font-24 fontMS300 text-white">
                    <br>
                    EL CONCILIO NO SOLO SE OCUPA DE LOS CONTENIDOS DE LAS TRADUCCIONES SINO TAMBIÉN INTRODUCE NUEVAS
                    ESTRATEGIAS DE EVANGELIZACIÓN. SE BUSCA CONVERTIR LA DINÁMICA DE PREGUNTA Y RESPUESTA EN UN
                    INTERCAMBIO REAL, UNA CONVERSACIÓN ENTRE EL CREYENTE Y EL CURA, PARA PODER VERIFICAR LA ASIMILACIÓN
                    DEL MENSAJE.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="text-white font-24">
                            Para lograr este objetivo se elaboran nuevos tipos de materiales en las lenguas originarias:
                            sermones, confesionarios, los cuatro evangelios y más. Estos materiales asumen un tono más
                            narrativo y persuasivo.
                        </p>
                        <p class="text-white font-24">
                            Los documentos seleccionados para esta sección recrean la trayectoria de la memorización a
                            la prédica. Empezando con <span class="fontMS100Italic">La primera gramática quichua</span>
                            (1560), se puede apreciar una reedición de uno de los textos más antiguos que se ha
                            conservado en quechua. <span class="fontMS100Italic">Tercero catechismo</span> (1583) es
                            representativo de las nuevas estrategias impulsadas por el Concilio. Presenta treinta y un
                            sermones en las que se contrasta la fe católica con las creencias de los indígenas.
                            Finalmente, la traducción del evangelio realizada por Clorinda Matto de Turner (1901) se
                            incluye por las licencias que la autora toma con el fin de hacer un texto accesible y
                            conmovedor.
                        </p>
                    </div>
                    <div class="col-sm-6 p3">
                        <div class="row">
                            <div class="col-sm-6">
                                <p style="padding-left: 2rem;" class="font-22 fontMS300 text-white">
                                    <span class="fontMS500">Fray Domingo de
                                        <br>Santo Tomás.</span><br>
                                    <span class="fontMS300Italic">La primera gramática quichua.</span>
                                    <br>Instituto Histórico Dominicano, 1947 (reedición).
                                </p>
                            </div>
                            <div class="col-sm-6">
                                <a href="http://hdl.handle.net/20.500.14428/79186">
                                    <img width="100%"
                                        src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img005.jpg">
                                </a>
                            </div>
                        </div>
                        <br><br>
                        <div class="row">
                            <div style="padding-left: 2rem;" class="col-sm-6">
                                <p style="padding-left: 1rem;" class="font-22 fontMS300 text-white"><span
                                        class="fontMS500">Anónimo.</span>
                                    <span class="fontMS300Italic">
                                        <br>Tercero catechismo. <br>
                                    </span>
                                    Antonio Ricardo, 1585.
                                </p>
                            </div>
                            <div class="col-sm-6">
                                <a href="https://hdl.handle.net/20.500.14428/66064">
                                    <img width="100%"
                                        src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img006.jpg">
                                </a>
                            </div>
                        </div>
                        <br><br>
                        <div class="row">
                            <div style="padding-left: 2rem;" class="col-sm-6">
                                <p style="padding-left: 1rem;" class="font-22 fontMS300 text-white"><span
                                        class="fontMS500">Clorinda Matto de Turner, trad.
                                    </span>
                                    <span class="fontMS300Italic"><br> Apunchis Jesu-cristoc evangelion San Lucaspa
                                        qquelkascan.
                                    </span>
                                    <br>
                                    Sociedad Bíblica Americana, 1901.
                                </p>
                            </div>
                            <div class="col-sm-6">
                                <a href="https://hdl.handle.net/20.500.14428/36685">
                                    <img width="100%"
                                        src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img007.jpg">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" width="100%">
            </div>
            <div class="col-sm-12">
                <p class="fontMS500 text-justify font-24 mt-3">
                    MOVIDOS POR LA NECESIDAD DE DAR UN IMPULSO DEFINITIVO A LA PREDICACIÓN, OTROS DOS JESUITAS, DIEGO
                    GONZÁLEZ HOLGUÍN Y LUDOVICO BERTONIO, CONCLUIRÁN EN LOS AÑOS SIGUIENTES LO QUE SE PUEDE CONSIDERAR
                    AÚN HOY COMO LAS MÁS IMPORTANTES CONTRIBUCIONES AL CONOCIMIENTO DE LAS LENGUAS QUECHUA Y AYMARA.
                </p>
            </div>
            <div class="col-sm-12 text-right mt-3 mb-3">
                <span class="fontMS500Italic font-24">
                    JUAN CARLOS ESTENSSORO FUCHS, 2003.
                </span>
            </div>
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondoWhiteStar">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio6\E03-MS08-GRAMA_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio6\E03-MS08-GRAMA_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LOS CLÁSICOS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio6\E03-MS08-GRAMA_LINEA1-recortada.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS300 text-center colorPrincipal font-40">
                    ENTRE LA SISTEMATIZACIÓN <br> Y EL LENGUAJE EXPRESIVO
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio6\E03-MS08-GRAMA_LINEA1-recortada.png">
                </div>
                <p class="font-24 fontMS500 fontMS500 text-center">
                    <br>
                    ENTRE 1584 Y 1619 SE PUBLICAN LO QUE HOY DÍA SE CONOCEN COMO LOS INCUNABLES PERUANOS, ES DECIR, LOS
                    PRIMEROS LIBROS IMPRESOS DEL PAÍS. ENTRE ESTAS PUBLICACIONES SE DESTACAN VARIAS GRAMÁTICAS Y
                    VOCABULARIOS QUE SE VAN A CONVERTIR EN LOS TEXTOS DE REFERENCIA POR EXCELENCIA PARA EL ESTUDIO DE
                    LAS LENGUAS ORIGINARIAS.
                </p>
                <p class="font-24 text-gris text-justify">
                    A pesar de todos los controles de contenido ya mencionados, los traductores más destacados de este
                    periodo trabajan el lenguaje con bastante libertad. Los voluminosos tomos de los jesuitas Diego
                    González Holguín y Ludovico Bertonio resaltan las posibilidades expresivas del quechua y el aymara.
                    Sobresale además la participación indígena en estas traducciones. González Holguín señala que los
                    indios de Cusco son los verdaderos autores de sus obras, mientras Ludovico Bertonio trabaja a dos
                    manos con el indígena Martín de Santa Cruz. Para estos estudiosos, no es necesario enaltecer las
                    lenguas originarias porque ya son elocuentes, capaces de expresar todo lo que se quisiera.
                </p>

                <!--CEL-->
                <div class="row p-5 menuWebPhone">
                    <div class="col-sm-4 mt-3">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/69704" target="_blank" style="color: inherit;">
                                <img width="100%" class="p-3 img-fluid imgNP_sp"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img008.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Diego de Torres Rubio.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Arte, y Vocabulario en la lengva general del Perv llamada Quichua, y en la
                                            lengua Española. El más copioso y elegante que hasta agora se ha impreso
                                            <br>
                                        </span>
                                        Antonio Ricardo, 1586.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/12968" target="_blank" style="color: inherit;">
                                <img class="p-3 imgNP_sp img-fluid"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img011.jpg" width="100%">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Diego González Holguín.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Gramatica y Arte Nveva de la lengva general de todo el Peru, llamada lengua
                                            Qquichua, o lengua del Inca.
                                            <br>
                                        </span>
                                        Francisco del Canto, 1607.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/13039" target="_blank" style="color: inherit;">
                                <img class="p-3 imgNP_sp img-fluid"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img014.jpg" width="100%">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Ludovico Bertonio.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Vocabulario de la lengua aymara.
                                            <br>
                                        </span>
                                        Francisco del Canto, 1612.
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-4 mt-8">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/13750" target="_blank" style="color: inherit;">
                                <img class="p-3 imgNP_sp img-fluid"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img009.jpg" width="100%">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Diego de Torres Rubio.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Arte y vocabvlario en la lengva general del Perv llamada quichua y en la
                                            lengua española. El más copioso y elegante que hasta agora se ha impresso.
                                            <br>
                                        </span>
                                        Francisco del Canto, 1614.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/36908" target="_blank" style="color: inherit;">
                                <img class="p-3 imgNP_sp img-fluid"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img012.jpg" width="100%">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Diego González Holguín.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Gramática y arte nueva de la lengua general de todo el Peru llamada lengua
                                            qquichua o lengua del inca.
                                            <br>
                                        </span>
                                        [s.e.], 1842 (reedición).
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/69713" target="_blank" style="color: inherit;">
                                <img class="p-3 imgNP_sp img-fluid"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img010.jpg" width="100%">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Diego de Torres Rubio.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Arte de la lengva quechva.
                                            <br>
                                        </span>
                                        Francisco Lasso, 1619.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/12946" target="_blank" style="color: inherit;">
                                <img class="p-3 imgNP_sp img-fluid"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img013.jpg" width="100%">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Diego González Holguín.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Vocabvlario de la Lengva General de todo el Perv llamada lengua Qquichua, o
                                            del Inca.
                                            <br>
                                        </span>
                                        Francisco del Canto, 1608.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/36937" target="_blank" style="color: inherit;">
                                <img class="p-3 imgNP_sp img-fluid"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img015.jpg" width="100%">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Ludovico Bertonio.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Vocabulario de la lengua aymara.
                                            <br>
                                        </span>
                                        B.G. Teubner, 1879 (reedición).
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>


                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/69704" target="_blank" style="color: inherit;">
                                <img width="100%" class="p-3 img-fluid imgNP_sp"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img008.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Diego de Torres Rubio.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Arte, y Vocabulario en la lengva general del Perv llamada Quichua, y en la
                                            lengua Española. El más copioso y elegante que hasta agora se ha impreso
                                            <br>
                                        </span>
                                        Antonio Ricardo, 1586.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/12968" target="_blank" style="color: inherit;">
                                <img class="p-3 imgNP_sp img-fluid"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img011.jpg" width="100%">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Diego González Holguín.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Gramatica y Arte Nveva de la lengva general de todo el Peru, llamada lengua
                                            Qquichua, o lengua del Inca.
                                            <br>
                                        </span>
                                        Francisco del Canto, 1607.
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/13039" target="_blank" style="color: inherit;">
                                <img class="p-3 imgNP_sp img-fluid"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img014.jpg" width="100%">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Ludovico Bertonio.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Vocabulario de la lengua aymara.
                                            <br>
                                        </span>
                                        Francisco del Canto, 1612.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/13750" target="_blank" style="color: inherit;">
                                <img class="p-3 imgNP_sp img-fluid"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img009.jpg" width="100%">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Diego de Torres Rubio.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Arte y vocabvlario en la lengva general del Perv llamada quichua y en la
                                            lengua española. El más copioso y elegante que hasta agora se ha impresso.
                                            <br>
                                        </span>
                                        Francisco del Canto, 1614.
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/36908" target="_blank" style="color: inherit;">
                                <img class="p-3 imgNP_sp img-fluid"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img012.jpg" width="100%">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Diego González Holguín.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Gramática y arte nueva de la lengua general de todo el Peru llamada lengua
                                            qquichua o lengua del inca.
                                            <br>
                                        </span>
                                        [s.e.], 1842 (reedición).
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/69713" target="_blank" style="color: inherit;">
                                <img class="p-3 imgNP_sp img-fluid"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img010.jpg" width="100%">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Diego de Torres Rubio.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Arte de la lengva quechva.
                                            <br>
                                        </span>
                                        Francisco Lasso, 1619.
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/12946" target="_blank" style="color: inherit;">
                                <img class="p-3 imgNP_sp img-fluid"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img013.jpg" width="100%">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Diego González Holguín.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Vocabvlario de la Lengva General de todo el Perv llamada lengua Qquichua, o
                                            del Inca.
                                            <br>
                                        </span>
                                        Francisco del Canto, 1608.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/36937" target="_blank" style="color: inherit;">
                                <img class="p-3 imgNP_sp img-fluid"
                                    src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img015.jpg" width="100%">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Ludovico Bertonio.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Vocabulario de la lengua aymara.
                                            <br>
                                        </span>
                                        B.G. Teubner, 1879 (reedición).
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio6\E03-MS08-GRAMA_LINEA1-recortada2.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio6\E03-MS08-GRAMA_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;margin-top: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            EL NUEVO AUGE
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio6\E03-MS08-GRAMA_LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="text-center fontMS300 colorPrincipal font-40">
                    DE LOS ESTUDIOS LINGÜÍSTICOS
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio6\E03-MS08-GRAMA_LINEA1-recortada.png">
                </div>
                <p class="font-24 text-center fontMS500">
                    <br>
                    EL ESTUDIO DE LAS LENGUAS ORIGINARIAS, SIEMPRE AL SERVICIO DE LA EVANGELIZACIÓN, CONTINÚA A LO LARGO
                    DEL SIGLO XVII. NO OBSTANTE, APENAS ENTRADA EL SIGLO XVIII, EMPIEZA UNA “EDAD OSCURA” PARA LOS
                    ESTUDIOS LINGÜÍSTICOS EN EL PERÚ. LA PRÉDICA EN LENGUAS ORIGINARIAS SE EMPIEZA A CUESTIONAR Y
                    EVENTUALMENTE ES PROHIBIDA.
                    <br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <img width="100%" src="\assets\images\micrositio\micrositio6\E03-MS08-GRAMA_MAPA01.png">
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24 text-gris text-justify fontMS300">
                            <br>
                            Un siglo y medio más tarde los misioneros, sobre todo franciscanos y redentoristas, retoman
                            la práctica de catequizar en lenguas originarias. Surgen de nuevo gramáticas, vocabularios,
                            catecismos. Ya no en el quechua cusqueño sino en los dialectos regionales del quechua y
                            también las lenguas amazónicas. Los autores de estos libros no son exclusivamente misioneros
                            europeos. Por ejemplo, José Franciscano María Raez y Saturnino Pastor Feria escriben sobre
                            el dialecto de su región natal, Huancayo y Cabanaconde respectivamente. Aunque estos
                            estudios no tengan la misma monumentalidad de sus predecesores, dejan constancia de la gran
                            diversidad lingüística del país.
                            <br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="w-90 text-center ml-auto mr-auto">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of slides" class="slide p-2">
                <a href="{{ slide.link }}" style="color: inherit;" target="_blank">
                    <div class="divLibros text-center w-100">
                        <p class="text-center">
                            <img src="{{ slide.img }}" alt="" width="100%">
                        </p>
                        <div class="divNombresLibros">
                            <p class="text-center">
                                <span>{{slide.autor}}</span><br>
                                <span>{{slide.titulo}}</span><br>
                                <span>{{slide.ano}}</span>
                            </p>
                        </div>
                    </div>
                </a>
            </div>
        </ngx-slick-carousel>
    </div>
</div>

<div class="fondoOrange">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <!-- <div class="col-sm-4">
                        <img class="img-fluid mb-3 pointer" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img008c.jpg">
                    </div> -->
                    <div class="col-sm-12">
                        <p class="text-white fontMS500 font-24">
                            A partir de 1583, empieza a crecer la lista de “préstamos” en las traducciones de los
                            catecismos. Para ciertos conceptos, como Dios, christiano o incluso rey, ya no se buscaba
                            términos equivalentes, sino que se imponía la palabra en castellano directamente. El
                            objetivo era evitar confusiones o sincretismos entre la cosmovisión indígena y la religión
                            católica.

                        </p>
                    </div>
                    <div class="col-sm-12 mb-5 mt-4">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿Qué es el sincretismo? ¿Por qué se quería evitar? ¿Crees que los préstamos consiguieron esa
                            meta?

                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            Fray Santo Domingo de Tomás es el primero en usar la palabra “quechua” para describir la
                            lengua imperial de los incas. Te invitamos a investigar sobre el origen de este término.
                            ¿Cuáles otros nombres se usan para referirse al quechua?

                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿Conoces algunos préstamos del quechua o el aymara que se han integrado al castellano?
                            ¿Cuáles son?
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio6\E03-MS08-GRAMA_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio6\E03-MS08-GRAMA_LINEA1-recortada2.png">
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <p class="font-24 text-gris">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="font-24">
                    <span class="fontMS500">Cerrón-Palomino, R. (1985).</span><br>
                    <span class="fontMS100Italic text-gris">
                        El franciscano Raez y la unificación del quechua. <br>
                    </span>
                    <span class="text-gris">
                        En: Anthropologica 3(3), 203-246.<br>
                    </span>
                    <a href="http://revistas.pucp.edu.pe/index.php/anthropologica/article/view/839/804" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Estenssoro Fuchs, J.C. (2003).<br>
                    </span>
                    <span class="fontMS100Italic text-gris">
                        Del paganismo a la santidad: La incorporación de los indios del Perú al catolicismo,
                        1532-1750.<br>
                    </span>
                    <span class="text-gris">Lima: IFEA.<br></span>
                    <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=285583" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Ezcurra, A. y Bendezú-Araujo, R. (2017).<br></span>
                    <span class="fontMS100Italic text-gris">
                        Gramáticas y vocabularios coloniales del quechua y del aimara (1560-1619).
                    </span>
                    <span class="text-gris">
                        En: Historia de las literaturas en el Perú, vol I. Lima: Casa de la Literatura, PUCP,
                        MINEDU.<br>
                    </span>
                    <a href="http://www.casadelaliteratura.gob.pe/wp-content/uploads/2017/04/Historia-de-la-literatura-Vol-1-1.pdf"
                        target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="font-24">
                    <span class="fontMS500">García Gayoso, I. et al (1996).<br></span>
                    <span class="fontMS100Italic text-gris">Incunables peruanos en la Biblioteca Nacional del Perú
                        (1584-1619).
                    </span>
                    <span class="text-gris">
                        Lima: BNP.<br>
                    </span>
                    <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/fondo-editorial/FE_035/files/assets/basic-html/page-7.html"
                        target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Martino Alba, P. (2015).<br></span>
                    <span class="fontMS100Italic text-gris">Las aportaciones lingüísticas y literarias de fray Domingo
                        de Santo Tomas.
                    </span>
                    <span class="text-gris">
                        En: Mutatis Mutandi: Revista Latinoamericana de Traducción 8(1): 8-27.<br>
                    </span>
                    <a href="https://revistas.udea.edu.co/index.php/mutatismutandis/article/view/21912/18298"
                        target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Toribio Medina, J. (1904).<br></span>
                    <span class="fontMS100Italic text-gris">La imprenta en Lima (1584-1824), tomo I.
                    </span>
                    <span class="text-gris">Santiago de Chile: Impreso en casa del autor.<br> </span>

                    <a href="https://bibliotecadigital.bnp.gob.pe/portal-bnp-web/#/libro/LIB-467" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
            </div>
        </div>
    </div>
</div>
<!-- Footer -->